// 🎨 Sistema de Temas - Definições Centralizadas
// Usado tanto no Admin quanto no Menu Público

export const themes = {
  default: {
    id: "default",
    name: "Padrão (Azul)",
    description: "Versátil para qualquer tipo de estabelecimento",
    icon: "🍽️",
    category: "Geral",
    colors: {
      primary: "#3B82F6",
      primaryHover: "#2563EB",
      primaryLight: "#EFF6FF",
      accent: "#60A5FA",
      success: "#10B981"
    }
  },
  
  acai: {
    id: "acai",
    name: "Açaí (Roxo Premium)",
    description: "Ideal para açaiterias e sorveterias premium",
    icon: "🍇",
    category: "Açaí & Sorvetes",
    colors: {
      primary: "#9333EA",
      primaryHover: "#7C3AED",
      primaryLight: "#F5F3FF",
      accent: "#C084FC",
      success: "#A855F7"
    }
  },
  
  burger: {
    id: "burger",
    name: "Hambúrguer (Laranja)",
    description: "Perfeito para hamburguerias e fast food",
    icon: "🍔",
    category: "Lanches & Fast Food",
    colors: {
      primary: "#F97316",
      primaryHover: "#EA580C",
      primaryLight: "#FFF7ED",
      accent: "#FB923C",
      success: "#FBBF24"
    }
  },
  
  hotdog: {
    id: "hotdog",
    name: "Hot Dog (Vermelho)",
    description: "Clássico para hot dogs e lanches de rua",
    icon: "🌭",
    category: "Lanches de Rua",
    colors: {
      primary: "#DC2626",
      primaryHover: "#B91C1C",
      primaryLight: "#FEF2F2",
      accent: "#F87171",
      success: "#FBBF24"
    }
  },
  
  healthy: {
    id: "healthy",
    name: "Saudável (Verde)",
    description: "Natural para restaurantes saudáveis e veganos",
    icon: "🥗",
    category: "Saudável & Natural",
    colors: {
      primary: "#16A34A",
      primaryHover: "#15803D",
      primaryLight: "#F0FDF4",
      accent: "#4ADE80",
      success: "#22C55E"
    }
  },

  minimal: {
    id: "minimal",
    name: "Minimalista (Preto)",
    description: "Elegante e sofisticado para estabelecimentos premium",
    icon: "⬛",
    category: "Premium & Minimalista",
    colors: {
      primary: "#18181B",
      primaryHover: "#09090B",
      primaryLight: "#F4F4F5",
      accent: "#3F3F46",
      success: "#52525B"
    }
  },

  navy: {
    id: "navy",
    name: "Navy Elegante (Azul Escuro)",
    description: "Sofisticado para restaurantes e cafeterias premium",
    icon: "🔵",
    category: "Premium & Sofisticado",
    colors: {
      primary: "#1E3A8A",
      primaryHover: "#1E40AF",
      primaryLight: "#EFF6FF",
      accent: "#3B82F6",
      success: "#60A5FA"
    }
  },

  coral: {
    id: "coral",
    name: "Coral Moderno (Rosa Vibrante)",
    description: "Jovem e vibrante para cafeterias e docerias",
    icon: "🌸",
    category: "Moderno & Jovem",
    colors: {
      primary: "#FB7185",
      primaryHover: "#F43F5E",
      primaryLight: "#FFF1F2",
      accent: "#FDA4AF",
      success: "#34D399"
    }
  },

  amber: {
    id: "amber",
    name: "Âmbar Luxo (Dourado)",
    description: "Luxuoso para churrascarias e estabelecimentos premium",
    icon: "✨",
    category: "Luxo & Premium",
    colors: {
      primary: "#D97706",
      primaryHover: "#B45309",
      primaryLight: "#FEF3C7",
      accent: "#F59E0B",
      success: "#FBBF24"
    }
  },

  teal: {
    id: "teal",
    name: "Teal Moderno (Turquesa)",
    description: "Fresco e moderno para poke bowls e frutos do mar",
    icon: "🌊",
    category: "Moderno & Fresco",
    colors: {
      primary: "#0D9488",
      primaryHover: "#0F766E",
      primaryLight: "#F0FDFA",
      accent: "#14B8A6",
      success: "#2DD4BF"
    }
  },

  wine: {
    id: "wine",
    name: "Vinho Sofisticado (Borgonha)",
    description: "Elegante para wine bars e restaurantes italianos",
    icon: "🍷",
    category: "Elegante & Refinado",
    colors: {
      primary: "#881337",
      primaryHover: "#9F1239",
      primaryLight: "#FFF1F2",
      accent: "#BE123C",
      success: "#FB7185"
    }
  },

  custom: {
    id: "custom",
    name: "Personalizado",
    description: "Crie sua própria paleta de cores",
    icon: "🎨",
    category: "Personalizado",
    colors: {
      primary: "#3B82F6",
      primaryHover: "#2563EB",
      primaryLight: "#EFF6FF",
      accent: "#60A5FA",
      success: "#10B981"
    }
  }
};

// Função auxiliar para obter cores de um tema
export const getThemeColors = (themeName) => {
  return themes[themeName]?.colors || themes.default.colors;
};

// Função para obter dados completos de um tema
export const getTheme = (themeName) => {
  return themes[themeName] || themes.default;
};

// Lista de IDs de temas válidos
export const validThemes = Object.keys(themes);

// Exportar como array para iteração
export const themesArray = Object.values(themes);
